import { render } from "./ActivityPageListComponents.vue?vue&type=template&id=f56ba896&scoped=true&ts=true"
import script from "./ActivityPageListComponents.vue?vue&type=script&lang=ts"
export * from "./ActivityPageListComponents.vue?vue&type=script&lang=ts"

import "./ActivityPageListComponents.vue?vue&type=style&index=0&id=f56ba896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56ba896"]])

export default __exports__